import { useEffect, useState } from "react";
import { ArrowUpRight, X } from "lucide-react";
import { API } from "@/lib/api";

const trackClick = (sessionId) =>
  fetch(`${API}/public/cta`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ session_id: sessionId }), keepalive: true }).catch(() => {});

export const CtaButton = ({ campaign, sessionId, testid, className = "" }) => (
  <a
    data-testid={testid} href={campaign.end_cta_url} target="_blank" rel="noreferrer" onClick={() => trackClick(sessionId)}
    className={`inline-flex items-center gap-2 h-12 px-7 rounded-full bg-pink-500 hover:bg-pink-400 font-semibold whitespace-nowrap transition-colors shadow-[0_0_40px_-8px_rgba(236,72,153,0.8)] ${className}`}
  >
    {campaign.end_cta_text || "Book a demo"} <ArrowUpRight className="w-4 h-4" />
  </a>
);

export const EndScreen = ({ campaign, sessionId, ended }) => {
  const [open, setOpen] = useState(false);
  useEffect(() => { if (ended) setOpen(true); }, [ended]);
  if (!open || !campaign.end_cta_url) return null;
  return (
    <div data-testid="end-screen-overlay" className="absolute inset-0 z-20 rounded-2xl bg-black/75 backdrop-blur-md grid place-items-center text-center px-6 sv-rise">
      <button data-testid="end-screen-close-button" onClick={() => setOpen(false)} className="absolute top-4 right-4 w-9 h-9 grid place-items-center rounded-full bg-white/10 hover:bg-white/20 transition-colors" title="Close">
        <X className="w-4 h-4" />
      </button>
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-pink-400 mb-3">Thanks for watching</p>
        <h3 className="font-display text-2xl sm:text-3xl font-bold mb-6">Ready for the next step?</h3>
        <CtaButton campaign={campaign} sessionId={sessionId} testid="end-screen-cta-button" />
      </div>
    </div>
  );
};
